module.exports = "../../../../platform/assets/pageMainIcon/ig-basic-archives-3.svg";